import { ref } from 'vue';
import { defineStore } from 'pinia';
import useSettingsStore from '../settings';
import { getEmpCode } from '../../../utils/auth';
import type { MenuItem } from '../menu/types';

export const useFavoritesCacheStore = defineStore(
  'favoritesCache',
  () => {
    const data = ref<Record<string, MenuItem>>({});

    return { data };
  },
  {
    // @ts-ignore
    get persist() {
      const {
        settings: { system },
      } = useSettingsStore();
      let key = getEmpCode();
      if (!key || !system) {
        return false;
      }

      key = `${system.systemCode || `${system.webTitle}-${system.webSubTitle}`}-${key}__FAVORITES`;
      const storage = localStorage;
      return { key, storage };
    },
  },
);
